import { render, staticRenderFns } from "./RepairWork.vue?vue&type=template&id=4508be56&scoped=true&"
import script from "./RepairWork.vue?vue&type=script&lang=js&"
export * from "./RepairWork.vue?vue&type=script&lang=js&"
import style0 from "./RepairWork.vue?vue&type=style&index=0&id=4508be56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508be56",
  null
  
)

export default component.exports